import React from "react";
import { Routes, Route } from "react-router-dom";
import GovernanceApp from "./GovernanceApp";
import DesignSystem from "../pages/DesignSystem.jsx";
import { NewsletterProvider } from "./context/NewsletterContext";

export default function App() {
  return (
    <NewsletterProvider>
      <Routes>
        <Route path="/design" element={<DesignSystem />} />
        <Route path="/*" element={<GovernanceApp />} />
      </Routes>
    </NewsletterProvider>
  );
}
